import React from "react";

export const XLargeCard: React.FC = () => {
  return (
    <div className="h-full w-full 2xl:px-3 2xl:py-5">
      <div className="bg-white mt-4 h-full rounded-md"></div>
    </div>
  );
};
